'use strict';

module.exports = require('./Trigger');


/*****************
 ** WEBPACK FOOTER
 ** ./~/.1.10.3@rc-trigger/lib/index.js
 ** module id = 40
 ** module chunks = 0 1
 **/